import React, { useState, useEffect } from 'react'
import NavBar from './Navbar';
import UserNavbar from './UserNavbar';
import Logo from './Logo';

import Languages from './Languages'
import Profileone from './Profileone';
import { USER_TYPE } from '../constants';
import { IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import RenderBtn from './RenderBtn';
import { useTranslation } from 'react-i18next';
function Header() {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  const { t } = useTranslation('global');


  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [drawerOpen, setDrawerOpen] = useState(false);


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  }

  const handleMenuClick = () => {
    alert('Menu clicked! Add Drawer or menu logic here.');
  };

  const drawerContent = (
    <Box
      sx={{ width: 220, padding: 2, display: 'flex', flexDirection: 'column', gap: 1, marginTop: 10 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <RenderBtn to="/home">{t('home')}</RenderBtn>
      <RenderBtn to="/users">{t('users')}</RenderBtn>
      <RenderBtn to="/progress">{t('progress')}</RenderBtn>
      <RenderBtn to="/programs">{t('programs')}</RenderBtn>
      <RenderBtn to="/alerts">{t('alerts')}</RenderBtn>
    </Box>
  );

  return (
    <div style={{
      //  width:'1240px',
      minHeight: '70px',
      padding: '0px 10px',
      marginBottom: '15px',
      borderRadius: '5px',
      background: '#FFFFFF 0% 0% no-repeat padding-box',
      display: 'flex',
      alignItems: 'center',
      zIndex: 9999,
      flex: 1,
      justifyContent: 'space-between',
      position: 'sticky',
      top: 0
    }}>
      <div
        style={{
          // width: '100%',
          display: 'flex',
          justifyContent: 'start',
          alignItems: 'center',
          // marginBottom: isMobile ? '10px' : 0,
        }}
      >
        {isMobile && (
          <>
            <IconButton onClick={toggleDrawer(true)}>
              <MenuIcon sx={{ fontSize: '28px' }} />
            </IconButton>

            <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
              {drawerContent}
            </Drawer>
          </>
        )}

        {/* Move Logo next to the menu icon */}
        <Logo />
      </div>

      {!isMobile ? userInfo && userInfo.userType === USER_TYPE.CLINICIAN ? <NavBar /> : <UserNavbar /> : null}

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Languages />
        <Profileone />
      </div>
    </div>


  )
}

export default Header